import $bizConfig from '@/models/bizConfig.js';
import $web3js from '../web3.js';
import $erc20 from '../erc20/index.js';

const contractInfo = require('./swapMiningContract.json')

let web3 = $web3js.getWeb3();

let contractAddress = $bizConfig.swapMiningContractAddress;
let contractConst = {
  contract: web3 ? new web3.eth.Contract(contractInfo.abi, contractAddress) : '',
}

const getSwapMiningAddress = () => {
  return contractAddress;
}

const getSwapMiningContract = () => {
  return contractConst.contract;
}

const getSwapMiningQuantity = async ([outputToken, outputAmount, anchorToken], options) => {
  outputAmount = await $erc20.toErc20Value(outputAmount, outputToken);
  return $web3js.call(getSwapMiningContract().methods.getQuantity, [outputToken, outputAmount, anchorToken], options, $erc20.fromErc20Value, [anchorToken]);
}

export default {
  getSwapMiningAddress,
  getSwapMiningContract,
  getSwapMiningQuantity,
}


// WEBPACK FOOTER //
// ./src/lib/contract/swapMining/index.js